// get parameters
export const getParameters = async (setLoading, state, api) => {
  setLoading(true);
  try {
    const response = await api;
    await state(response.data);
  } catch (e) {
    console.log(e);
  } finally {
    setLoading(false);
  }
};

// get Environment parameters
export const getParamsEnvironment = async (...args) => {
  if (args.length === 4) {    
    const [promise, setNearest, setLoading, setError] = args;
    setLoading(true);
    try {
      const res = await promise;
      if (res.status === 200) {
        setNearest(res.data);
      }
    } catch (e) {
      setError(true);
      console.log('from here',e);
    } finally {
      setLoading(false);
    }
  } else {    
    const [
      promise1,
      promise2,
      setChemicalStations,
      setWaterCours,
      setLoading,
    ] = args;
    try {
      setLoading(true);
      const [result1, result2] = await Promise.allSettled([promise1, promise2]);
      // Handle the results
      if (result1.status === 'fulfilled') {
        setChemicalStations(result1.value.data);         
      }
      if (result2.status === 'fulfilled') {
        setWaterCours(result2.value.data);
      }
    } catch(error) {
      console.log('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }
}

// Handle form and display seccess/error message Toast
export const handleOnSubmit = async (
  setLoading,
  api,
  toastSucess,
  toastError,
  state,
) => {
  const isValid = true;
  if (isValid) {
    setLoading(true);
    let shouldRefresh = false;
    try {
      const res = await api;
      shouldRefresh = true;
      if (res.status === 200) {
        toastSucess.current.show({
          severity: 'success',
          summary: 'Succès',
          detail: 'Données de paramètre enregistrées',
          life: 8000,
        });
      }
    } catch (e) {
      toastError.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail:
          "Erreur lors de l'enregistrement des données de paramètre enregistrées",
        life: 8000,
      });
    } finally {
      setLoading(false);
    }
    if (shouldRefresh) {
      await getParameters(setLoading, state, api);
    }
  }
}

